// extracted by mini-css-extract-plugin
export default {"items":"Report_items__gz5s2","item":"Report_item__Jw2I7","icon":"Report_icon__drfym","info":"Report_info__o1Mik"};